import { createSlice } from '@reduxjs/toolkit'



export const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    filter: {
      log_date_from:  { enabled: true, value: '' },
      log_date_to:    { enabled: true, value: '' },
      log_user:       { enabled: true, value: '' },
      log_type:       { enabled: true, value: '' },
      log_hotelcode:  { enabled: true, value: '' },
    },
    pagination: {
      recordsPerPage: 25,
      actualPage: 1,
      numberOfPages: 1
    },
    sorting: {
      by: 'log_date',
      direction: 'DESC'
    },
    isFiltered : false,
    isSearching: false,
    result: {
      numberOfRecordsTotal: 0,
      numberOfRecords: 0,
      records: []
    },
    userId: null,
    activeSection: null,
  },
  reducers: {
    setFilterValue: (state, action) => {
      state.filter[action.payload.filter].value = action.payload.value;
    },

    setSearching: (state, action) => {
      state.isSearching = action.payload;
    },
    
    setResult: (state, action) => {
      state.pagination.actualPage = 1;
      state.pagination.numberOfPages = 1;

      state.result.records = action.payload.result;
      state.result.numberOfRecords = parseInt(action.payload.result.length);
      state.result.numberOfRecordsTotal = parseInt(action.payload.numberOfRecordsTotal);
      state.isFiltered = true;

      // set sorting if provided
      if (action.payload.sorting) {
        state.sorting = action.payload.sorting;
      }

      // reset paginatiom
      state.pagination.actualPage = 1;
      state.pagination.numberOfPages = 1;
    },

    addResult: (state, action) => {
      if (action.payload) {
        action.payload.forEach(record => {
          state.result.records.push(record);
        });
        state.result.numberOfRecords += parseInt(action.payload.length);
        state.isFiltered = true;

        state.pagination.actualPage = state.pagination.actualPage + 1;
        state.pagination.numberOfPages = state.pagination.numberOfPages + 1;
      }
    },

    setUserId: (state, action) => {
      state.userId = action.payload;
    },

    setActiveSection: (state, action) => {
      state.activeSection = action.payload;
    },
  },
})

// Action creators are generated for each case reducer function
export const { setFilterValue, setResult, addResult, setSearching, setUserId, setActiveSection } = settingsSlice.actions

export default settingsSlice.reducer